// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__3xi53","about__section":"About_about__section__28aSH","about__text":"About_about__text__1rjBH"};